import { ACTIONS_FROM_SM, REDUCERS } from '../../constants.js';

const initialNoAvailableState = {
  reducer_type : REDUCERS.REDUCER_ACTIOS_FROM_SM,
  time : 0,
  frame : 0,
  description : "",
  supervisorPass : false
}

const noAvailableState = (state = initialNoAvailableState, action) => {
  if(action.type === ACTIONS_FROM_SM.NO_AVAILABLE_INFO){
    return {  frame : action.frame, time : action.time, supervisorPass : action.supervisorPass, description : action.description};
  }else{
    return state;
  }
}

export default noAvailableState;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_no_available.js